export default {
  ANONYMOUS: 'ANONYMOUS',
  SUBSCRIBER: 'SUBSCRIBER',
};
